export default (that) => [
    {
      field: 'seq',
      width: 50,
      align: 'center',
      type: 'seq',
    },
    {
      field: 'col-opt',
      title: that.$l('INDEX.table_label_operation') || '操作',
      headerAlign: 'center',
      align: 'center',
      width: 120,
      slots: {
        default: 'opt',
      },
    },
    {
      field: 'checkbox',
      width: 40,
      align: 'center',
      type: 'checkbox',
      visible: !that.disabled,
    },
    {
      title: that.$l('INDEX.order_doc_orderDocFileType') || '文档类型',
      field: 'v_orderDocFileType',
      width: 100,
      align: 'center',
      showHeaderOverflow: true,
      showOverflow: true,
    },
    {
      title: that.$l('INDEX.order_doc_fileName') || '文件名',
      field: 'fileName',
      minWidth: 300,
      headerAlign: 'center',
      align: 'left',
      showHeaderOverflow: true,
      showOverflow: true,
    },
    {
      title: that.$l('INDEX.order_doc_remark') || '文档说明',
      field: 'remark',
      minWidth: 200,
      headerAlign: 'center',
      align: 'left',
      showHeaderOverflow: true,
      showOverflow: true,
    },
    {
      title: that.$l('INDEX.order_doc_uploadByName') || '上传人姓名',
      field: 'uploadByName',
      width: 120,
      headerAlign: 'center',
      align: 'left',
      showHeaderOverflow: true,
      showOverflow: true,
    },
    {
      title: that.$l('INDEX.order_doc_uploadTime') || '上传时间',
      field: 'uploadTime',
      width: 170,
      align: 'center',
      showHeaderOverflow: true,
      showOverflow: true,
    },
  ]
  